import { buildApiMutationHook } from '../utils/api';
import axiosI from './base.api';

export type ContactUsParams = {
  description: string;
  email?: string | null;
  phoneNo?: string | null;
};

export type ContactUsResult = undefined;

export const useContactUs = buildApiMutationHook<ContactUsParams, ContactUsResult>((data) =>
  axiosI.post('/contact-us', data),
);
